import React, { useState } from "react";
import "./userSideBar.css"; // Import the CSS file for styling

const UserSideBar = () => {
  const [menuOpen, setMenuOpen] = useState(false); // State to track menu open/close

  // Toggle menu open/close
  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Switch the state
  };

  return (
    <div id="mySidenav" className={`sidenav ${menuOpen ? "open" : ""}`}>
      <a href="/user" id="Userbutt">User Homepage</a>
      <a href="/weather" id="Weatherbutt">Weather Query</a>
      <a href="/news" id="Newsbutt">Technology News</a>
      <a href="/leetcode" id="leetcodebutt">Leetcode Notes</a>
      <a href="/movies" id="moviebutt">Movie Sharing</a>
      <button id="MenuOpen" onClick={toggleMenu}>
        {menuOpen ? "Open Menu" : "Close Menu"}
      </button>
    </div>
  );
};

export default UserSideBar;
